import { useSteles } from '@/hooks/useSteles';
import { Roster } from '@/components/Roster';
import { DocsSection } from '@/components/SidePanel';
import { useUIStore } from '@/state/store';

export function Sidebar() {
  const { steles } = useSteles();
  // pre165: Session-Ablage in die linke Leiste verlagert (nur während eines Gesprächs).
  // pre172: unten angedockt, wächst nach oben, max. 1/3 Höhe (dann scrollen, neuste oben),
  // begrenzt den Raum für die Berater-/Gruppenansicht (Roster).
  const inCall = useUIStore((s) => s.view).startsWith('incall');

  return (
    <aside className="sidebar">
      {/* Welle 9: Stelen-Status — Status nur als Punkt-Icon (Text „online/offline" entfällt) */}
      <div className="sidebar-section">
        <div className="section-label">
          Stelen <span className="count">{steles.filter((s) => s.status === 'online').length}/{steles.length}</span>
        </div>
        {steles.length === 0 && (
          <div className="stele-item" style={{ opacity: 0.5 }}>
            <div className="name">Keine Stelen</div>
          </div>
        )}
        {steles.map((s) => (
          <div key={s.id} className={`stele-item ${s.status === 'online' ? 'online' : ''}`} style={{ opacity: s.enabled ? 1 : 0.45 }} title={`${s.location ? s.location + ' · ' : ''}${s.status === 'online' ? 'online' : 'offline'}`}>
            <div className="name">{s.name}</div>
          </div>
        ))}
      </div>

      {/* Welle 9: Kombinierte Gruppen-/Berater-Ansicht mit Suche + Pickup */}
      <div style={{ flex: 1, minHeight: 0, overflowY: 'auto' }}>
        <Roster />
      </div>

      {inCall && (
        <div className="sidebar-docs-dock">
          <DocsSection />
        </div>
      )}
    </aside>
  );
}
